import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, Expo, TimelineLite, TimelineMax, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";

import {hh_ch2_72dpi_p0304} from "../../../layouts/ch2_p03/hh_ch2_72dpi_p03-04"

export class Chapter2Page3 extends AbstractStoryState {

	readonly bg = this.addChild(new SceneSprite());
	readonly piper = this.addChild(new SceneSprite());
	readonly amy = this.addChild(new SceneSprite());
	readonly chairHolly = this.addChild(new SceneSprite());
	readonly chairOscar = this.addChild(new SceneSprite());
	readonly oscar = this.addChild(new SceneSprite());
	readonly holly = [this.addChild(new SceneSprite()), this.addChild(new SceneSprite())];
	readonly table = this.addChild(new SceneSprite());
	readonly phoneGlow = this.addChild(new SceneSprite());
	readonly phoneArm = this.addChild(new SceneSprite());
	readonly holly1Arms = this.addChild(new SceneSprite());
	readonly oscarArms = this.addChild(new SceneSprite());
	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch2_p03/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch2_p03/"));
    readonly lines = this.addChild(SceneSprite.withPrefix("ch2_p03/"));

	readonly phoneHitArea = new Array<number>();

	dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layout from Animate CC
        hh_ch2_72dpi_p0304.call(this);
        this.holly[1].visible = false;
        this.phoneArm.visible = false;
        this.phoneGlow.visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
		super.update(pDeltaTime);
	}

	public animateIn(pOnComplete: ()=>void) {
		super.animateIn(pOnComplete);
	}

	protected onAnimateInComplete() {
		new TimelineLite()
            .call(()=>{
                this.holly[1].FadeIn();
                this.phoneArm.FadeIn();

                this.holly[0].FadeOut();
                this.holly1Arms.FadeOut();
				// HLF.Application.instance.audio.play("HH_Ch2_HollyPhoneVibrate_FX", undefined, false, HLF.AudioCategory.SFX);
			}, undefined, undefined, 0.5)
			.call(()=>{
				this.phoneGlow.visible = true;
				const t = new TimelineMax();
				t.fromTo(this.phoneGlow, 2, {pixi: {alpha: 0}}, {pixi: {alpha: 1}});
				t.yoyo(true);
				t.repeat(-1);
				super.onAnimateInComplete();
			}, undefined, undefined, 1)
			.call(()=>{
				this.gotoNextState({transition: "left"});
			}, undefined, undefined, "+=1.5")
            .delay(3.5);
	}
}